import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  InputAdornment,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  ListItemButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BarcodeScanner, { BarcodeFormat } from "react-qr-barcode-scanner";
import { PersonSearch } from "@mui/icons-material";

/**
 * Props:
 * - open: boolean
 * - slotId: string | number
 * - slotLabel: string
 * - initialValues?: { nombre?: string, documento?: string }  // para ocupar o para liberar (puede venir prellenado)
 * - onCancel: () => void
 * - onConfirm: (payload: { slotId, slotLabel, nombre, documento }) => void
 */
export default function BusquedaDialog({
  open,
  espacio,
  onCancel,
  onConfirm,
}) {
  const [data, setData] = React.useState('');
  const [valorDeBusqueda, setValorDeBusqueda] = React.useState("");

  const [reservasDelEspacio, setReservasDelEspacio] = React.useState([]);
  const [reservas, setReservas] = React.useState([]);

  const actualizarReservasDelEspacio = () => {
    setReservasDelEspacio(espacio?.slots.filter(slot => !!slot.visitante).map(slot => {return {ubicacion: slot, visitante: slot.visitante}}) ?? []);
  }

  const handleConfirmar = (item) => {
    item.ubicacion.visitante = item.visitante;
    onConfirm?.(item);
  };

  const handleClose = () => {
    onCancel();
  }

  React.useEffect(() => {
    if (reservasDelEspacio.length > 0) {
      setReservas(reservasDelEspacio.filter(item => item.visitante.nombre.toLowerCase().includes(valorDeBusqueda.toLowerCase()) || item.visitante.documento.toLowerCase().includes(valorDeBusqueda.toLowerCase()) ))
    } else {
      setReservas([]);
    }
  }, [reservasDelEspacio, valorDeBusqueda]);

  React.useEffect(() => {
    actualizarReservasDelEspacio();
  }, [espacio]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{zIndex: 10}}
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        Busqueda de Visitante
        <IconButton
          onClick={handleClose}
          aria-label="Cerrar"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Ingrese toda o parte de la información
          </Typography>

          <TextField
            label="Nombre o Documento"
            value={valorDeBusqueda}
            onChange={(e) => setValorDeBusqueda(e.target.value)}
            autoFocus
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlineIcon fontSize="small" />
                  </InputAdornment>
                ),
            }}}
          />

          {/* <Button variant="outlined" startIcon={<PersonSearch />} onClick={handleBuscar}>Buscar</Button> */}
          <List>
            {(reservas.length == 0) && <ListSubheader>No hay reservas que coincidan</ListSubheader>}
            {reservas.map((item) => {
              return (
                <ListItem key={item.ubicacion.id} disablePadding>
                  <ListItemButton onClick={() => handleConfirmar(item)}>
                    {/* <ListItemText primary={'Ubicación: ' + item.ubicacion.label} /> */}
                    {/* <ListItemText primary={item.visitante.nombre} secondary={item.visitante.documento} /> */}
                    <ListItemText primary={item.visitante.nombre}  />
                    <ListItemText primary={item.visitante.documento} sx={{textAlign: 'right'}} />
                  </ListItemButton>
                </ListItem>
            )})}
          </List>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
